import { render, staticRenderFns } from "./VuebaseLayout.vue?vue&type=template&id=eae9eb94"
import script from "./VuebaseLayout.vue?vue&type=script&lang=js"
export * from "./VuebaseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports